var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnorderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.075 1.735c0 .338.274.612.612.612h5.749a.612.612 0 0 0 0-1.223h-5.75a.612.612 0 0 0-.61.611zm-4.894 0C.181.947.815.308 1.608.308c.788 0 1.428.634 1.428 1.427 0 .788-.634 1.428-1.428 1.428A1.424 1.424 0 0 1 .181 1.735zm5.506 5.953h5.749a.612.612 0 1 0 0-1.223h-5.75a.612.612 0 1 0 0 1.223zM.18 7.077c0-.788.634-1.428 1.427-1.428.788 0 1.428.634 1.428 1.428 0 .788-.634 1.427-1.428 1.427A1.424 1.424 0 0 1 .181 7.077z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorderedList);
export default __webpack_public_path__ + "static/media/unordered-list.ed0ae2b55f26a1a9adb72f1f9c3e4420.svg";
export { ForwardRef as ReactComponent };